module.exports = __webpack_public_path__ + "img/Human_symbol_4.abc51577.png";